(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("zMultiCache", [], factory);
	else if(typeof exports === 'object')
		exports["zMultiCache"] = factory();
	else
		root["zMultiCache"] = factory();
})(window, function() {
return 